import { request } from './http.js'

/**
 * 首页工作台：一次请求拿全（健康度 + KPI + 待办 + 系统状态 + 数据源新鲜度）。
 * 后端是「只读聚合」，不做分页 —— 待办条数天然是十几条量级，跨境一次往返比多次便宜。
 */
export function fetchDashboardTodo() {
  return request('/api/dashboard/todo')
}
